export const PROPERTIES_COLLECTION = 'beyondMaps-properties';
export const PORTFOLIOS_COLLECTION = 'beyondMaps-portfolios';
export const LAYERS_COLLECTION = 'beyondMaps-layers';
